var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "registerForm",
        staticClass: "sign-up",
        attrs: { tag: "form", novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onRegister.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              var errors = ref.errors
              return [
                !_vm.hideTitle
                  ? _c("h2", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("login.registerTitle")),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.registerResponse.message
                  ? _c("GeneralMessage", {
                      attrs: {
                        message: _vm.registerResponse.message,
                        type: _vm.registerResponse.type,
                      },
                      on: {
                        close: function ($event) {
                          _vm.registerResponse.message = ""
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "form-row__wrapper",
                  attrs: {
                    name: "firstname",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("forms.labels.firstname"),
                                label: _vm.$t("forms.labels.firstname"),
                                error: invalid && validated,
                                "error-message": errors[0],
                                disabled: _vm.disabled,
                                required: "",
                              },
                              model: {
                                value: _vm.registerForm.firstName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.registerForm, "firstName", $$v)
                                },
                                expression: "registerForm.firstName",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "form-row__wrapper",
                  attrs: {
                    name: "lastname",
                    rules: "required",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("forms.labels.lastname"),
                                label: _vm.$t("forms.labels.lastname"),
                                error: invalid && validated,
                                "error-message": errors[0],
                                disabled: _vm.disabled,
                                required: "",
                              },
                              model: {
                                value: _vm.registerForm.lastName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.registerForm, "lastName", $$v)
                                },
                                expression: "registerForm.lastName",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  ref: "registerEmail",
                  staticClass: "form-row__wrapper",
                  attrs: {
                    name: "email",
                    rules: "required|email",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      email: _vm.$t("forms.errors.emailInvalid"),
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "email",
                                placeholder: _vm.$t("forms.labels.email"),
                                label: _vm.$t("forms.labels.email"),
                                error: invalid && validated,
                                "error-message": errors[0],
                                disabled: _vm.disabled,
                                hint: _vm.$t("login.registerEmailHint"),
                                required: "",
                              },
                              model: {
                                value: _vm.registerForm.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.registerForm, "email", $$v)
                                },
                                expression: "registerForm.email",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row__wrapper" },
                  [
                    _c("FormInputDate", {
                      attrs: {
                        placeholder: _vm.$t("forms.labels.birthday"),
                        label: _vm.$t("forms.labels.birthday"),
                        labelOption: _vm.$t("forms.labels.optional"),
                        "max-date": "today",
                      },
                      model: {
                        value: _vm.registerForm.birthday,
                        callback: function ($$v) {
                          _vm.$set(_vm.registerForm, "birthday", $$v)
                        },
                        expression: "registerForm.birthday",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "form-row__wrapper",
                  attrs: {
                    name: "password",
                    rules: "required|complexpw",
                    vid: "password",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      complexpw: _vm.$t("forms.errors.password"),
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                placeholder: _vm.$t("forms.labels.password"),
                                label: _vm.$t("forms.labels.password"),
                                error: invalid && validated,
                                "error-message": errors[0],
                                disabled: _vm.disabled,
                                required: "",
                              },
                              model: {
                                value: _vm.registerForm.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.registerForm, "password", $$v)
                                },
                                expression: "registerForm.password",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("ValidationProvider", {
                  staticClass: "form-row__wrapper",
                  attrs: {
                    name: "confirm",
                    vid: "confirm",
                    rules: "required|confirmed:password",
                    tag: "div",
                    customMessages: {
                      required: _vm.$t("forms.errors.fieldEmpty"),
                      confirmed: _vm.$t("forms.errors.passwordMatch"),
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          var invalid = ref.invalid
                          var validated = ref.validated
                          var dirty = ref.dirty
                          return [
                            _c("FormInput", {
                              attrs: {
                                type: "password",
                                placeholder: _vm.$t(
                                  "forms.labels.passwordRepeat"
                                ),
                                label: _vm.$t("forms.labels.passwordRepeat"),
                                error: invalid && validated,
                                "error-message": errors[0],
                                disabled: _vm.disabled,
                                required: "",
                              },
                              model: {
                                value: _vm.registerForm.confirm,
                                callback: function ($$v) {
                                  _vm.$set(_vm.registerForm, "confirm", $$v)
                                },
                                expression: "registerForm.confirm",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _vm.showPhone
                  ? _c("ValidationProvider", {
                      staticClass: "form-row__wrapper",
                      attrs: {
                        name: "phone",
                        rules: "required|phone_int",
                        tag: "div",
                        customMessages: {
                          required: _vm.$t("forms.errors.fieldEmpty"),
                          phone_int: _vm.$t("forms.errors.phone"),
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              var invalid = ref.invalid
                              var validated = ref.validated
                              return [
                                _c("FormInput", {
                                  attrs: {
                                    type: "tel",
                                    placeholder: _vm.$t("forms.labels.phone"),
                                    label: _vm.$t("forms.labels.phone"),
                                    error: errors.length > 0,
                                    "error-message": errors[0],
                                    disabled: !!_vm.isLoggedIn,
                                    hint: _vm.$t("login.phoneHint"),
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.registerForm.phoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.registerForm,
                                        "phoneNumber",
                                        $$v
                                      )
                                    },
                                    expression: "registerForm.phoneNumber",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ValidationProvider", {
                  attrs: {
                    rules: { required: { allowFalse: false } },
                    name: "checkTerms",
                    tag: "div",
                    customMessages: { required: _vm.$t("login.errorTerms") },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var errors = ref.errors
                          var validated = ref.validated
                          return [
                            _c(
                              "FormInputCheckbox",
                              {
                                attrs: {
                                  name: "terms",
                                  value: "checkTerms",
                                  error: errors.length > 0,
                                  "error-message": errors[0],
                                  required: "",
                                  immediate: "",
                                  disabled: _vm.disabled,
                                },
                                model: {
                                  value: _vm.registerForm.checkTerms,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "checkTerms",
                                      $$v
                                    )
                                  },
                                  expression: "registerForm.checkTerms",
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("login.termsLabel")
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "submit",
                    level: "primary",
                    text: _vm.$t("login.registerButton"),
                    disabled: _vm.disabled,
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }